/* @ngInject */
function RecentsController ($scope, $location, $rootScope, $state, $window, $translate, $timeout, $q, RepositoryService, AssetPreviewService, Utils, UdsModalService, AdminService, SegmentService, ToastService) {
  const getMoveToTrashDialogController = () => import('../../dialogs/move-to-trash/move-to-trash-dialog.controller')
  const getUpgradeCompanyPlanDialogController = () => $q.when(import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller'))
  const getModulesPricingDialogController = () => $q.when(import('../../../core/dialogs/modules-pricing/modules-pricing-dialog.controller'))
  const getChooseDocTemplateDialogController = () => $q.when(import('../../dialogs/choose-doc-template/choose-doc-template-dialog.controller'))

  $scope.currentPage = 'recents'
  $scope.emptyState = {
    imgPath: 'empty-state-' + $scope.currentPage,
    title: $translate.instant('repository.emptyState.' + $scope.currentPage + '.title'),
    message: $translate.instant('repository.emptyState.' + $scope.currentPage + '.message')
  }
  $scope.hasShowMoreButton = false
  $scope.pagination = {
    $top: 30,
    $skip: 0
  }
  $scope.companyFeatures = {
    importFiles: {
      access: true
    }
  }
  $scope.goBackRoute = ''

  $scope.sections = [
    { slug: 'today', assets: [], totalCount: 0 },
    { slug: 'thisweek', assets: [], totalCount: 0 },
    { slug: 'lastmonth', assets: [], totalCount: 0 },
    { slug: 'thisyear', assets: [], totalCount: 0 }
  ]

  $scope.filters = {
    type: null,
    extension: null,
    tags: null,
    excludeExtensions: null
  }
  $scope.searching = false

  let title = ''
  let advancedSearchFilters = null

  let loadingSectionIndex = 0

  const api = {
    getModulesPricingDialogController,
    getUpgradeCompanyPlanDialogController,
    getMoveToTrashDialogController,
    getChooseDocTemplateDialogController,
    _openPricingUpgradeDialog,
    _loadAssets,
    _hasMoreResults,
    _handlePricing,
    _resetAllSections,
    _setHeader,
    _searchAssets,
    _clearSearch,
    _handleAdvancedSearch,
    _handleAdvancedFilters,
    _onAdvancedSearchAssetClick,
    _openMoveToTrashDialog,
    _removeAssetFromList,
    _removeAssetsFromList,
    _findAssetInSections,
    _reloadAssetsAfterUploadHandler,
    _importFiles,
    _trackSearch,
    _openChooseDocTemplateDialog
  }

  this.getApi = () => api

  function activate () {
    $scope.initialLoad = true

    const path = $location.path().replace(/^\//, '')
    $scope.goBackRoute = path

    api._loadAssets()
      .then(() => {
        $timeout(() => {
          $scope.initialLoad = false
        }, 2000)
      })
  }

  activate()

  $scope.$watchCollection('headerToolbar.repositoryFilter.params', (fileTypes) => {
    if ($scope.initialLoad) {
      return
    }

    let fileType = null

    for (const type in fileTypes) {
      if (fileTypes[type]) {
        fileType = type
        break
      }
    }

    $scope.filters.type = fileType
    $scope.filters.extension = null

    api._searchAssets()
  })

  const deregisterAssetsArchive = $scope.$on('repository.assets-archive', (e, archivedAssets) => {
    api._removeAssetsFromList(archivedAssets)
  })

  function _removeAssetsFromList (selectedAssets) {
    $timeout(() => {
      selectedAssets.forEach((selectedAsset) => {
        const assetIndex = $scope.sections[0].assets.findIndex(asset => asset.id === selectedAsset.id)
        if (assetIndex >= 0) {
          $scope.sections[0].assets.splice(assetIndex, 1)
          $scope.sections[0].totalCount--
        }
      })
      $scope.selectedAssets = []
    })
  }

  const deregisterReloadAssetsAfterUpload = $rootScope.$on('reload-assets-after-upload', (e, uploadedAssets) => {
    api._reloadAssetsAfterUploadHandler(uploadedAssets)
  })

  const deregisterExtensionFilterUpdate = $scope.$on('repository-filters.extension-filter-update', (e, extension) => {
    if ($scope.initialLoad) {
      return
    }

    $scope.filters.extension = extension

    api._resetAllSections()
    api._loadAssets()
  })

  const deregisterOnAttachModalSearch = $scope.$on('attach-asset-modal.search', (_, term) => {
    $scope.assetSearch = term
    api._searchAssets()
  })

  $scope.$on('$destroy', () => {
    deregisterOnAttachModalSearch()
    deregisterReloadAssetsAfterUpload()
    deregisterExtensionFilterUpdate()
    deregisterAssetsArchive()
  })

  $scope.loadAssets = api._loadAssets

  function _resetAllSections () {
    $scope.$broadcast('repository.load-assets-start')
    $scope.hasShowMoreButton = false

    loadingSectionIndex = 0
    $scope.pagination.$skip = 0
    $scope.sections.forEach((section) => {
      section.assets = []
      section.totalCount = 0
    })
  }

  function _reloadAssetsAfterUploadHandler (uploadedAssets) {
    $timeout(() => {
      api._resetAllSections()
      api._loadAssets(uploadedAssets.length)
        .then(() => {
          const reloadedAssets = uploadedAssets.map((uploadedAsset) => {
            return $scope.sections[0].assets.find((sectionAsset) => sectionAsset.id === uploadedAsset.id)
          })
          let allowedAssets = reloadedAssets

          if ($scope.allowedAssetExtensionsSelection?.length) {
            allowedAssets = reloadedAssets.filter(asset => {
              return $scope.allowedAssetExtensionsSelection.includes(asset.extension)
            })
          }

          if ($scope.modalState) {
            $scope.$broadcast('asset-card.set-assets-selected', allowedAssets)
          }
        })
    }, 500)
  }

  /**
   * @param {number} [untilRegisterNumber] Makes new requests until the specified number of records or more is reached.
   */
  function _loadAssets (untilRegisterNumber) {
    const loadingSection = $scope.sections[loadingSectionIndex]

    if (!loadingSection) {
      $scope.initialLoad = false
      $scope.$broadcast('repository.load-assets-end')
      return Promise.resolve()
    }

    if ($scope.showOnlyExtension && !Array.isArray($scope.showOnlyExtension)) {
      $scope.filters.extension = $scope.showOnlyExtension
    }

    if ($scope.removeExtensions) {
      $scope.filters.excludeExtensions = $scope.removeExtensions
    }

    return RepositoryService.getRecentsAssets({
      section: loadingSection.slug,
      $top: $scope.pagination.$top,
      $skip: $scope.pagination.$skip,
      search: $scope.assetSearch,
      filters: $scope.filters
    })
      .then((assets) => {
        if (!assets.count) {
          loadingSectionIndex++
          return api._loadAssets()
        }

        $scope.pagination.$skip = $scope.pagination.$skip += $scope.pagination.$top
        loadingSection.assets = loadingSection.assets.concat(assets.rows)
        $scope.hasShowMoreButton = api._hasMoreResults(assets.count, loadingSection.assets.length)
        loadingSection.totalCount = assets.count
        $scope.$broadcast('repository.load-assets-end')

        if (untilRegisterNumber && $scope.pagination.$skip < untilRegisterNumber) {
          return api._loadAssets(untilRegisterNumber)
        }

        if (loadingSection.assets.length >= assets.count) {
          $scope.pagination.$skip = 0
          loadingSectionIndex++
          return api._loadAssets()
        }
      })
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return Number(totalCount) > responseLength
  }

  function _setHeader () {
    const headerInfo = RepositoryService.getHeader(
      $scope.searching,
      title,
      {
        hasAdvancedSearch: true,
        hasFilters: true,
        searchAssets: api._handleAdvancedSearch,
        clearSearch: api._clearSearch,
        onSearchAssetClick: api._onAdvancedSearchAssetClick,
        advancedFilters: advancedSearchFilters,
        onFilter: api._handleAdvancedFilters
      }
    )

    if ($scope.filters.type) {
      headerInfo.headerToolbar.repositoryFilter.params.all = false
      headerInfo.headerToolbar.repositoryFilter.params[$scope.filters.type] = true
    }

    api._handlePricing().then(() => {
      const importButton = {
        type: 'button',
        btnType: 'primary',
        icon: 'upload',
        label: $translate.instant('upload'),
        pricing: {
          prop: !$scope.companyFeatures.importFiles.access,
          tooltip: $translate.instant('billingTooltips.haveMoreWithPro'),
          position: 'left'
        },
        onClick: api._importFiles
      }

      const createNewButton = $scope.hasDocAccess ? {
        type: 'dropdown',
        btnType: 'secondary',
        label: $translate.instant('createNew'),
        dropdownPosition: 'right',
        icon: 'plus',
        options: [
          {
            icon: 'deskfy-file',
            label: $translate.instant('document'),
            onClick: api._openChooseDocTemplateDialog
          }
        ]
      } : null

      headerInfo.headerToolbar.rightButtons = [
        createNewButton,
        importButton
      ]

      $scope.headerToolbar = headerInfo.headerToolbar
      $scope.headerNavigation = headerInfo.headerNavigation
      $scope.headerTitle = headerInfo.headerTitle
    })
  }

  function _importFiles (event) {
    const { pricing } = event.currentTarget

    if (pricing) {
      return api._openPricingUpgradeDialog($translate.instant('addFiles'), 'REPOSITORIES.IMPORT_MATERIALS')
    }

    $window.showOpenFilePicker({
      multiple: true
    }).then((filesInstances) => {
      if (!filesInstances?.length) {
        return
      }

      const mappedFiles = filesInstances.map((file) => file.getFile())
      return Promise.all(mappedFiles).then((files) => {
        $rootScope.$emit('upload-tab.upload-new-assets', files)
      })
    })
  }

  function _handleAdvancedSearch (term, tags = []) {
    $scope.sections.forEach(section => {
      section.searchedAssets = []
      section.searchedCount = null
    })

    $scope.searching = !!term
    $scope.assetSearch = term
    $scope.filters.tags = tags

    api._searchAssets()
    api._setHeader()
  }

  function _searchAssets () {
    if ($scope.initialLoad) {
      return
    }

    api._trackSearch()
    api._resetAllSections()
    api._loadAssets()
  }

  function _trackSearch () {
    const {
      tags,
      designers,
      createdBy,
      modules,
      assetId,
      createdAt,
      updatedAt,
      type
    } = $scope.filters
    const term = $scope.assetSearch

    SegmentService.track('file-search', {
      tab_name: 'Meus recentes',
      filter_text: term,
      filter_tag: tags,
      filter_permission: designers,
      filter_create_for: createdBy,
      filter_use_on: modules,
      filter_code_id: assetId,
      filter_create_date: createdAt,
      filter_update_date: updatedAt,
      filter_extension_type: type
    })
  }

  function _clearSearch () {
    $scope.searching = false
    api._setHeader()

    $scope.assetSearch = ''
    $scope.filters.tags = null
    api._loadAssets()
  }

  function _handleAdvancedFilters (filters) {
    if ($scope.initialLoad) return

    if (!filters) {
      $scope.filters = {}
      api._searchAssets()

      return
    }

    const filtersKeys = Object.keys(filters)
    filtersKeys.forEach(key => {
      const currentFilter = filters[key]
      const isEmptyArray = Array.isArray(currentFilter) && !currentFilter.length
      const isEmptyValue = currentFilter === null || currentFilter === ''

      if (isEmptyArray || isEmptyValue) {
        $scope.filters[key] = null
        return
      }

      $scope.filters[key] = currentFilter
    })

    api._searchAssets()
  }

  function _findAssetInSections (asset) {
    let returnObj = { section: [], assetIndex: 0 }
    $scope.sections.forEach((section, index) => {
      const assetIndex = section.assets.findIndex(sectionAsset => sectionAsset.id === asset.id)

      if (assetIndex > -1) {
        returnObj = {
          section: $scope.sections[index],
          assetIndex
        }
      }
    })

    return returnObj
  }

  function _onAdvancedSearchAssetClick (asset) {
    if (asset.cardType === 'folder') {
      return $state.go('repository.organizedFolder', {
        id: asset.id
      })
    }

    if (AssetPreviewService.assetPreviewIsOpen()) {
      return
    }

    const { section, assetIndex } = api._findAssetInSections(asset)

    AssetPreviewService.openAssetPreview({
      asset: asset,
      location: 'repository',
      getPreviewAssets: () => {
        return Promise.resolve({
          assets: [asset],
          count: 1
        })
      },
      onDeleteAsset: (asset) => {
        api._openMoveToTrashDialog(asset, section, assetIndex)
      }
    })
  }

  function _openMoveToTrashDialog (asset, section, assetIndex) {
    api.getMoveToTrashDialogController().then(({ MoveToTrashController }) => {
      const nameDisplayLength = 32
      const assets = [{
        id: asset.id,
        assetSize: Utils.getReadableFileSizeString(asset.size),
        assetName: RepositoryService.defineFullAssetNameToDisplay(asset, nameDisplayLength),
        assetIcon: RepositoryService.defineAssetIconBasedOnExtension(asset)
      }]

      const moveToTrashDialog = UdsModalService.createModal({
        controller: MoveToTrashController,
        modalName: 'moveToTrashDialog',
        data: {
          assets
        },
        onClose: hasMoved => {
          if (hasMoved) {
            api._removeAssetFromList(section, assetIndex)
            AssetPreviewService.closePreview()
          }
        }
      })

      moveToTrashDialog.open()
    })
  }

  function _removeAssetFromList (section, assetIndex) {
    $timeout(() => {
      section.assets.splice(assetIndex, 1) // remove asset from list
      section.totalCount--
    })
  }

  function _handlePricing () {
    return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      const hasImportFilesFeature = !!features[String('REPOSITORIES.IMPORT_MATERIALS')]

      $scope.companyFeatures.importFiles.access = hasImportFilesFeature
    })
  }

  $translate.onReady(() => {
    const allUsedInOptions = [
      { label: $translate.instant('materials'), value: 'arts', slug: 'ARTS.ACCESS' },
      { label: $translate.instant('posts'), value: 'posts', slug: 'POSTS.ACCESS' },
      { label: $translate.instant('checklist'), value: 'checklist', slug: 'CHECKLIST.ACCESS' },
      { label: $translate.instant('dashboard.brandSettings'), value: 'brand', slug: 'BRAND.ACCESS' },
      { label: $translate.instant('requests'), value: 'workflow', slug: 'WORKFLOW.ACCESS' }
    ]

    let usedInOptions = []

    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      usedInOptions = allUsedInOptions.filter(option => features[String(option.slug)])
      const hasTagsFeature = !!features['REPOSITORIES.TAGS']

      title = $translate.instant('repository.sidebarSections.recents')
      advancedSearchFilters = [
        {
          name: 'tags',
          type: 'INPUT_MULTISELECT',
          grouped: false,
          defaultValue: [],
          props: {
            label: $translate.instant('repository.filters.filterByTags'),
            placeholder: $translate.instant('repository.filters.typeTags'),
            emptyMsg: $translate.instant('noResults'),
            loadButtonLabel: $translate.instant('loadMore'),
            type: 'tag',
            hasMoreOptions: true,
            udsDisabled: false,
            options: [],
            pricing: {
              show: !hasTagsFeature,
              tooltip: $translate.instant('billingTooltips.haveMoreWithPro'),
              tooltipPosition: 'top',
              onClick: () => {
                api._openPricingUpgradeDialog($translate.instant('tags'), 'REPOSITORIES.TAGS')
              }
            }
          },
          loadData: (search, top, skip) => RepositoryService.getAllAssetTags({ top, skip }, search)
        },
        {
          name: 'designers',
          type: 'INPUT_MULTISELECT',
          grouped: true,
          defaultValue: [],
          props: {
            label: $translate.instant('repository.filters.accessByDesigner'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            loadButtonLabel: $translate.instant('loadMore'),
            type: 'user',
            hasMoreOptions: true,
            udsDisabled: false,
            options: []
          },
          loadData: (search, top, skip) => AdminService.getUsers(top, skip, { search, role: ['DESIGNER'], active: true })
        },
        {
          name: 'createdBy',
          type: 'INPUT_MULTISELECT',
          grouped: true,
          defaultValue: [],
          props: {
            label: $translate.instant('repository.filters.createdBy'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            loadButtonLabel: $translate.instant('loadMore'),
            type: 'user',
            hasMoreOptions: true,
            udsDisabled: false,
            options: []
          },
          loadData: (search, top, skip) => AdminService.getUsers(top, skip, { search })
        },
        {
          name: 'modules',
          type: 'INPUT_MULTISELECT',
          grouped: true,
          defaultValue: [],
          props: {
            label: $translate.instant('repository.filters.usedIn'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            type: 'text',
            hasMoreOptions: false,
            udsDisabled: false,
            options: []
          },
          loadData: search => {
            const deferred = $q.defer()

            if (search) {
              const filteredItems = Utils.searchByArray(usedInOptions, search)
              deferred.resolve({
                rows: filteredItems,
                count: filteredItems.length
              })
            }

            if (!search) {
              deferred.resolve({
                rows: usedInOptions,
                count: usedInOptions.length
              })
            }

            return deferred.promise
          }
        },
        {
          name: 'assetId',
          type: 'INPUT',
          grouped: true,
          defaultValue: [],
          props: {
            label: $translate.instant('repository.filters.idCode'),
            placeholder: $translate.instant('repository.filters.typeCode'),
            type: 'text',
            udsDisabled: false
          }
        },
        {
          name: 'createdAt',
          type: 'DATE_PICKER',
          grouped: true,
          defaultValue: null,
          props: {
            locale: $rootScope.oUser.locale,
            label: $translate.instant('repository.filters.creationDate'),
            firstDayOfWeek: '1',
            direction: 'right'
          }
        }, {
          name: 'updatedAt',
          type: 'DATE_PICKER',
          grouped: true,
          defaultValue: null,
          props: {
            locale: $rootScope.oUser.locale,
            label: $translate.instant('repository.filters.changeDate'),
            firstDayOfWeek: '1',
            direction: 'right'
          }
        }, {
          name: 'customFields',
          props: {
            mustShowCustomFields: true
          }
        }
      ]

      $rootScope.getCompanyFeatures().then((companyFeatures) => {
        $scope.hasDocAccess = companyFeatures.includes('DOCUMENTS_MODULE')
        api._setHeader()
      })
    })
  })

  function _openPricingUpgradeDialog (featureName, featureSlug) {
    return $rootScope.getCompanyWithBillingPackage().then((companyBillingPackage) => {
      const isLegacy = Boolean(companyBillingPackage?.billingPackage?.plan?.pricingPackage?.legacy)

      if (!isLegacy) {
        return api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
          const modal = UdsModalService.createModal({
            controller: UpgradeCompanyPlanDialogController,
            modalName: 'upgradeCompanyPlanDialog',
            data: {
              featureName,
              featureSlug
            }
          })

          modal.open()
        })
      }

      return api.getModulesPricingDialogController().then(({ ModulesPricingDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: ModulesPricingDialogController,
          modalName: 'modulesPricingDialog',
          data: {
            module: {
              icon: 'files'
            }
          }
        })

        modal.open()
      })
    })
  }

  function _openChooseDocTemplateDialog () {
    api.getChooseDocTemplateDialogController().then(({ ChooseDocTemplateDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: ChooseDocTemplateDialogController,
        modalName: 'chooseDocTemplateDialog',
        data: {
          location: 'repository'
        }
      })
      modal.open()
    })
  }
}

export { RecentsController }
